import { Link, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Home, ArrowLeft, Search } from 'lucide-react'
import { useAuthStore } from '@/stores/auth'

export function NotFound() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-8">
        {/* Logo */}
        <div className="w-16 h-16 mx-auto mb-4">
          <img
            src="/ms_icon_light.svg"
            alt="Mission Solar Logo"
            className="w-full h-full object-contain"
          />
        </div>

        {/* 404 Message */}
        <div className="space-y-4">
          <h1 className="text-6xl font-bold text-primary">404</h1>
          <h2 className="text-2xl font-semibold">Seite nicht gefunden</h2>
          <p className="text-muted-foreground">
            Die angeforderte Seite konnte nicht gefunden werden.
            Sie wurde möglicherweise verschoben oder existiert nicht mehr.
          </p>
        </div>

        {/* Action buttons */}
        <div className="space-y-3">
          <Button
            onClick={() => navigate(-1)}
            variant="default"
            className="w-full"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Zurück zur vorherigen Seite
          </Button>

          {isAuthenticated ? (
            <>
              <Button
                asChild
                variant="outline"
                className="w-full"
              >
                <Link to="/dashboard">
                  <Home className="mr-2 h-4 w-4" />
                  Zum Dashboard
                </Link>
              </Button>

              <Button
                asChild
                variant="outline"
                className="w-full"
              >
                <Link to="/search">
                  <Search className="mr-2 h-4 w-4" />
                  Knowledge Base durchsuchen
                </Link>
              </Button>
            </>
          ) : (
            <>
              <Button
                asChild
                variant="outline"
                className="w-full"
              >
                <Link to="/auth/login">
                  <Home className="mr-2 h-4 w-4" />
                  Zur Anmeldung
                </Link>
              </Button>

              <Button
                asChild
                variant="outline"
                className="w-full"
              >
                <Link to="/public">
                  <Search className="mr-2 h-4 w-4" />
                  Öffentliche Knowledge Base
                </Link>
              </Button>
            </>
          )}
        </div>

        {/* Help text */}
        <p className="text-sm text-muted-foreground">
          Bei anhaltenden Problemen wenden Sie sich bitte an{' '}
          <a
            href="mailto:support@mission-solar.at"
            className="text-primary hover:underline"
          >
            support@mission-solar.at
          </a>
        </p>
      </div>
    </div>
  )
}